import React, { useEffect, useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  previewUpgrade,
  clearPreview,
} from "../../redux/slices/subscriptionPaymentSlice";
import { FiX } from "react-icons/fi";

const UpgradeConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  currentPlan,
  currentInterval,
  selectedPlanName,
  billingCycle,
  userId,
  priceId,
}) => {
  const dispatch = useDispatch();

  const { previewData, isPreviewLoading, previewError } = useSelector(
    (state) => state.subscriptionPayment
  );

  const [isProcessing, setIsProcessing] = useState(false); // ⭐ added

  useEffect(() => {
    if (show && priceId && userId) {
      dispatch(previewUpgrade({ userId, newPriceId: priceId }));
    }

    return () => {
      dispatch(clearPreview());
      setIsProcessing(false); // reset when modal closes
    };
  }, [show, priceId, userId, dispatch]);

  const formatCycle = (cycle) => (cycle === "year" ? "Yearly" : "Monthly");

  // const handleConfirm = async () => {
  //   setIsProcessing(true);
  //   await onConfirm();
  //  window.location.reload(); // refresh page

  //   setIsProcessing(false);
  // };
const handleConfirm = async () => {
  setIsProcessing(true);
  await onConfirm();

  const url = new URL(window.location.href);
  url.searchParams.set('reload', Date.now()); 
  window.location.href = url.toString();
};

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      dialogClassName="custom-modal confirm-upgrade-summary"
    >
      <Modal.Header>
        <h5 className="modal-title">Confirm Upgrade</h5>
        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        {isPreviewLoading && (
          <div className="text-center py-4">
            <Spinner animation="border" variant="primary" className="mb-3" />
            <p className="text-muted">Calculating charges...</p>
          </div>
        )}

        {previewError && !isPreviewLoading && (
          <div className="error-message text-center">{previewError}</div>
        )}

        {previewData && !isPreviewLoading && (
          <div className="content">
            <div className="mb-2">
              <div className="title">Upgrade Summary</div>

              <div className="plan-content">
                <span className="text-muted">Current Plan:</span>
                <strong>
                  {previewData.current_plan
                    ? // BE label already includes the interval ("Pro + Newsletter (Monthly)")
                      previewData.current_plan
                    : // Fallback when BE didn't resolve a label — append interval from props
                      `${currentPlan || "Current Plan"}${
                        currentInterval ? ` (${formatCycle(currentInterval)})` : ""
                      }`}
                </strong>
              </div>

              <div className="plan-content">
                <span className="text-muted">New Plan:</span>
                <strong>
                  {selectedPlanName} ({formatCycle(billingCycle)})
                </strong>
              </div>

              {/* <div className="d-flex justify-content-between mb-2">
                                <span className="text-muted">New Plan Cost:</span>
                                <span>${previewData.new_plan_cost?.toFixed(2)}</span>
                            </div> */}

              {previewData.proration_credit > 0 && (
                <div className="plan-content text-success">
                  <span>Credit from current plan:</span>
                  <strong>-${previewData.proration_credit?.toFixed(2)}</strong>
                </div>
              )}

              <hr className="my-2 mt-1" />

              <div className="total-plan-content">
                <strong>Amount charged today:</strong>
                <strong className="total text-primary">
                  ${previewData.amount_due?.toFixed(2)}
                </strong>
              </div>
            </div>

            {previewData.billing_cycle_reset && previewData.next_charge_date && (
              <div className="alert alert-info mb-0">
                <small>
                  <strong>Note:</strong> Your billing cycle will reset to today.
                  Next charge on{" "}
                  {new Date(
                    Date.now() +
                      (billingCycle === "year" ? 365 : 30) * 24 * 60 * 60 * 1000
                  ).toLocaleDateString("en-US", {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  })}
                </small>
              </div>
            )}

            <div className="mt-3">
              <p className="small text-muted mb-0">
                Payment will be processed immediately using your saved payment
                method.
              </p>
            </div>
          </div>
        )}

        <div className="actions">
          <Button
            className="btn btn-secondary"
            onClick={onHide}
            disabled={isProcessing}
          >
            Cancel
          </Button>

          <Button
            className="btn btn-primary"
            onClick={handleConfirm}
            disabled={
              isPreviewLoading || !!previewError || !previewData || isProcessing
            }
          >
            {isProcessing ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  className="me-2"
                />
                Processing...
              </>
            ) : (
              "Confirm & Pay"
            )}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UpgradeConfirmationModal;
